export const WEATHERAPI = "https://api.weatherbit.io/v2.0/current";
export const LAT = "4.732539"; //4.732539  anterior => 4.736610
export const LNG = "-73.911276"; //-73.911276 anterior => -73.907915
export const LANG = "es";

//Query photos
export const PhotoThemes = "?building,city,construction,industrial"
export const PhotoThemesBackground = "?construction,industrial"
